import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

const cleanupWindowPaneStateMutator: (tabId: string) => void = mutatorAction(
    'cleanupWindowPaneState',
    (tabId: string): void => {
        getStore().paneStateMap.delete(tabId);
    }
);

export default cleanupWindowPaneStateMutator;
